module.exports = __webpack_public_path__ + "img/extensionproc.b188f6fe.svg";